import { TheoryApiAxiosBase } from '@/repository/base/axiosBase';
import { SignInResponse } from '@/@types/Auth';

export class AuthRepository {
  private readonly axios = new TheoryApiAxiosBase();
  /** ログイン時、アカウントの情報を取得 */
  async signIn () {
    return (await this.axios.get<SignInResponse>(
      'v1/auth/sign-in',
    )).data;
  }
}
